<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [customBack]="'more'"
    [title]="'Profile'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <ng-container *ngIf="loaded">
      <!-- <mock-data-button
        [credentialTypes]="credentialTypes"
        (dataFilled)="ionViewDidEnter()">
      </mock-data-button> -->

      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Manage your business profile. Credentials will be reviewed by our team before appearing on your profile.'">
        </tidy-text>
      </tidy-row>

      <ng-container *ngFor="let section of sections">
        <tidy-row class="extra-top-padding">
          <tidy-text [header]="section.label"></tidy-text>
        </tidy-row>

        <ng-container *ngFor="let item of section.items">
          <tidy-card>
            <tidy-card-button class="arrow-to-top" [hideArrow]="true" (action)="toggleExpand(item)">
              <tidy-image
                [src]="item.isExpanded ? 'assets/svg/close-outline.svg' : 'assets/svg/create-outline.svg'"
                class="right-item chevron-icon no-right-margin"
                style="opacity: 0.4; width: 20px;">
              </tidy-image>
              <tidy-text [header]="item.type.key_label"></tidy-text>
              <ng-container *ngIf="!item.isExpanded">
                <ng-container *ngIf="hasFileUrl(item); else textDisplay">
                  <ng-container *ngIf="isImageUrl(item.existingCredential.file_url); else docDisplay">
                    <div style="margin-top: 6px;">
                      <img
                        [src]="item.existingCredential.file_url"
                        style="max-width: 60px; max-height: 60px; border-radius: 6px; object-fit: cover;"
                        alt="Uploaded">
                    </div>
                  </ng-container>
                  <ng-template #docDisplay>
                    <tidy-row class="extra-top-padding vertical-align-center">
                      <tidy-image
                        [src]="'assets/svg/checkmark-circle-outline.svg'"
                        style="width: 16px; height: 16px;">
                      </tidy-image>
                      <tidy-text [helper]="getFileTypeLabel(item.existingCredential.file_url) + ' Uploaded'"></tidy-text>
                    </tidy-row>
                  </ng-template>
                </ng-container>
                <ng-template #textDisplay>
                  <tidy-row class="extra-top-padding">
                    <tidy-text [helper]="getDisplayValue(item)"></tidy-text>
                  </tidy-row>
                </ng-template>
              </ng-container>
            </tidy-card-button>

            <ng-container *ngIf="item.isExpanded">
              <div style="padding: 12px 0;">
                <ng-container [ngSwitch]="getInputType(item)">

                  <!-- Textarea (bio) -->
                  <ng-container *ngSwitchCase="'textarea'">
                    <tidy-row>
                      <tidy-textarea
                        [label]="item.type.key_label"
                        [form]="item.formControl"
                        [formControl]="item.formControl"
                        [icon]="'assets/svg/text.svg'"
                        [activeIcon]="'assets/svg/text-tidy-green.svg'">
                      </tidy-textarea>
                    </tidy-row>
                  </ng-container>

                  <!-- URL -->
                  <ng-container *ngSwitchCase="'url'">
                    <tidy-row>
                      <tidy-input
                        [label]="item.type.key_label"
                        [form]="item.formControl"
                        [formControl]="item.formControl"
                        [placeholder]="'https://...'"
                        [icon]="'assets/svg/globe-outline.svg'"
                        [activeIcon]="'assets/svg/globe-outline.svg'">
                      </tidy-input>
                    </tidy-row>
                  </ng-container>

                  <!-- Number -->
                  <ng-container *ngSwitchCase="'number'">
                    <tidy-row>
                      <tidy-input
                        [label]="item.type.key_label"
                        [form]="item.formControl"
                        [formControl]="item.formControl"
                        [type]="'number'"
                        [inputMode]="'numeric'"
                        [icon]="'assets/svg/text.svg'"
                        [activeIcon]="'assets/svg/text-tidy-green.svg'">
                      </tidy-input>
                    </tidy-row>
                  </ng-container>

                  <!-- Toggle -->
                  <ng-container *ngSwitchCase="'toggle'">
                    <tidy-row class="vertical-align-center">
                      <tidy-text [body]="item.type.key_label"></tidy-text>
                      <tidy-toggle
                        [toggled]="item.toggleValue"
                        (toggleChanged)="onToggleChange(item, $event)"
                        style="margin-left: 12px;">
                      </tidy-toggle>
                    </tidy-row>
                  </ng-container>

                  <!-- File: Profile Image (photo) -->
                  <ng-container *ngSwitchDefault>
                    <ng-container *ngIf="item.type.key === 'profile_image'; else genericFileUpload">
                      <!-- Existing photo: show preview + remove -->
                      <ng-container *ngIf="item.uploadedFileUrl">
                        <tidy-row>
                          <img
                            [src]="item.uploadedFileUrl"
                            style="max-width: 120px; border-radius: 8px; object-fit: cover;"
                            alt="Profile image">
                        </tidy-row>
                        <tidy-row class="extra-top-padding">
                          <tidy-text
                            class="link red"
                            [actionBody]="'Remove'"
                            (action)="removeFile(item)">
                          </tidy-text>
                        </tidy-row>
                      </ng-container>
                      <!-- No photo: show upload button -->
                      <ng-container *ngIf="!item.uploadedFileUrl">
                        <tidy-row>
                          <tidy-file-upload
                            [accept]="'image/*'"
                            [multiple]="false"
                            [label]="'Upload Photo'"
                            [images]="item.uploadedImages"
                            [showPreview]="true"
                            [showDeleteButton]="true"
                            [showDownloadButton]="false"
                            (addedImagesChange)="onFilesAdded(item, $event)"
                            (removedImageChange)="onFileRemoved(item)"
                            (onError)="onFileError(item, $event)">
                          </tidy-file-upload>
                        </tidy-row>
                      </ng-container>
                    </ng-container>

                    <!-- File: Generic (certifications) -->
                    <ng-template #genericFileUpload>
                      <ng-container *ngIf="item.uploadedFileName">
                        <tidy-two-column-row style="margin-bottom: 10px;">
                          <tidy-text [body]="item.uploadedFileName"></tidy-text>
                          <tidy-text
                            [actionBody]="'remove'"
                            (action)="removeFile(item)"
                            class="link red">
                          </tidy-text>
                        </tidy-two-column-row>
                      </ng-container>
                      <ng-container *ngIf="!item.uploadedFileName">
                        <div style="margin-bottom: 10px;">
                          <tidy-button
                            [text]="'Upload File'"
                            [action]="pickFile.bind(this, item)"
                            class="secondary">
                          </tidy-button>
                        </div>
                      </ng-container>
                      <tidy-row *ngIf="item.isUploading">
                        <tidy-text [helper]="'Uploading file...'"></tidy-text>
                      </tidy-row>
                    </ng-template>
                  </ng-container>

                </ng-container>

                <tidy-error-message
                  *ngIf="item.errorMessage"
                  [text]="item.errorMessage">
                </tidy-error-message>

                <tidy-button
                  [text]="'Save'"
                  [action]="saveCredential.bind(this, item)"
                  class="primary">
                </tidy-button>
              </div>
            </ng-container>

            <tidy-row *ngIf="shouldShowStatusIcon(item)" style="padding: 4px 0;">
              <ion-chip
                class="credential-status-chip"
                [ngClass]="{'credential-status-rejected': item.existingCredential?.status === 'rejected'}">
                <span>{{getStatusChipText(item)}}</span>
              </ion-chip>
            </tidy-row>
          </tidy-card>
        </ng-container>
      </ng-container>

      <tidy-error-message
        *ngIf="errorMessage"
        [text]="errorMessage">
      </tidy-error-message>
    </ng-container>

    <ng-container *ngIf="!loaded">
      <tidy-card>
        <tidy-card-button [hideArrow]="true">
          <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        </tidy-card-button>
      </tidy-card>
      <tidy-card>
        <tidy-card-button [hideArrow]="true">
          <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
        </tidy-card-button>
      </tidy-card>
    </ng-container>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
